import { MenuItem, TextField } from '@mui/material';
import React from 'react';
import { useMatch } from 'react-router-dom';

const PaymentMethod = ({ billingDetails, handleInputChange, paymentMethods }) => {
  const selfAssessment = useMatch('/assessments/*');

  return (
    <>
      <h3>Select Payment Method</h3>
      <TextField
        size="small"
        select
        label="Payment Method"
        fullWidth
        margin="dense"
        name="paymentMethod"
        value={billingDetails.paymentMethod}
        onChange={handleInputChange}>
        {paymentMethods?.includes(1) && <MenuItem value={1}>Online</MenuItem>}
        {!selfAssessment && paymentMethods?.includes(0) && <MenuItem value={0}>Cash</MenuItem>}
      </TextField>
    </>
  );
};

export default PaymentMethod;
